import React from 'react';
import classNames from 'classnames';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import {useSelectCustomerPopupContext} from '../../contexts/SelectCustomerPopupContext';
import {RivhitCustomer} from '../../../../common/types';
import add from '../../../../common/assets/icons/add.svg';
import styles from './CustomersListItem.module.scss';

const CustomersListItem = (customer: RivhitCustomer) => {
  const {closePopup, select} = useSelectCustomerPopupContext();

  const handleSelect = (customer: RivhitCustomer) => {
    try {
      select(customer);
    } finally {
      closePopup();
    }
  };

  return (
    <div className={styles.lineContainer}>
      <div
        className={classNames(styles.column, styles.truncateColumn)}
        title={customer.customerName}
      >
        {customer.customerName}
      </div>
      <div className={classNames(styles.column, styles.truncateColumn)}>
        {customer.idNumber}
      </div>
      <div className={classNames(styles.column, styles.truncateColumn)}>
        {customer.phoneFax}
      </div>
      <div
        className={classNames(styles.column, styles.truncateColumn)}
        title={customer.address}
      >
        {customer.address}
      </div>
      <div className={classNames(styles.column, styles.actionColumn)}>
        <ButtonAction
          variant={'icon'}
          icon={add}
          onClick={() => handleSelect(customer)}
          customClassnames={{
            container: styles.button,
            label: styles.buttonLabel,
            icon: styles.buttonIcon
          }}
        />
      </div>
    </div>
  );
};

export default CustomersListItem;
